import { IFulfillBackordersDTO } from "@models/DTO/IFulfillBackordersDTO";
import React, { useState } from "react";
import OwLabel from "../OwLabel/OwLabel";
import OwToggle from "../OwToggle/OwToggle";
import { IFulfillBackordersByOrderDTO } from "@models/DTO/IFulfillBackordersByOrderDTO";
import OwTitle from "../OwTitle/OwTitle";
import { OwIconTooltip } from "../OwIconTooltip/OwIconTooltip";
import OwButton from "../OwButton/OwButton";

type Props = {
    closeFn: () => void;
    fulfillFn: (payload: Partial<IFulfillBackordersByOrderDTO>) => void;
};

export const FulfillBackordersModal = (props: Props) => {
    const [payload, setPayload] = useState<Partial<IFulfillBackordersByOrderDTO>>({
        autoFulfill: false,
        createBackorderForRemaining: false,
        useHeldInventoryFirst: true,
    });

    const fulfillFn = () => {
        props.fulfillFn(payload);
    };

    const change = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setPayload({ ...payload, [name]: value });
    };

    return (
        <div className={"FulfillBackordersModal p-2"}>
            <div>
                <OwTitle title="fulfill_options" tag="h4" />
            </div>
            <div className="mb-2 d-flex align-items-center gap-2">
                <OwToggle label="auto_fulfill" name="autoFulfill" active={payload.autoFulfill || false} fn={change} labelOnRight={true} />
                <OwIconTooltip iconClassName="fas fa-info-circle" tooltipContent="tooltip_auto_fulfill" translateContent={true} />
            </div>

            <div className="mb-2 d-flex align-items-center gap-2">
                <OwToggle
                    label="create_backorder_for_remaining"
                    name="createBackorderForRemaining"
                    active={payload.createBackorderForRemaining || false}
                    fn={change}
                    labelOnRight={true}
                />
                <OwIconTooltip
                    iconClassName="fas fa-info-circle"
                    tooltipContent="tooltip_create_backorder_for_remaining"
                    translateContent={true}
                />
            </div>

            <div className="mb-2 d-flex align-items-center gap-2">
                <OwToggle
                    label="use_held_inventory_first"
                    name="useHeldInventoryFirst"
                    active={payload.useHeldInventoryFirst || true}
                    fn={change}
                    labelOnRight={true}
                />
                <OwIconTooltip
                    iconClassName="fas fa-info-circle"
                    tooltipContent="tooltip_use_held_inventory_first"
                    translateContent={true}
                />
            </div>

            <div className="mt-4">
                <OwButton title="fulfill_orders" fn={fulfillFn} />
                <OwButton className="ms-2 btn-danger" title="cancel" fn={props.closeFn} />
            </div>
        </div>
    );
};
